// Service for by-product to raw material mapping CRUD operations
import api from './api';

export interface ByproductMapping {
  id: number;
  raw_material_item_number: string;
  byproduct_item_number: string;
  notes: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  raw_material_name: string | null;
  raw_material_chinese_name: string | null;
  byproduct_name: string | null;
  byproduct_chinese_name: string | null;
}

export interface RawMaterialItem {
  item_number: string;
  item_english_name: string | null;
  item_chinese_name: string | null;
  category_code: string | null;
}

export interface InventorySearchResult {
  item_number: string;
  item_english_name: string | null;
  item_chinese_name: string | null;
  category_code: string | null;
}

const byproductMappingService = {
  async getMappings(rawMaterial?: string): Promise<ByproductMapping[]> {
    const params = rawMaterial ? { rawMaterial } : {};
    const response = await api.get('/production/byproduct-mappings', { params });
    return response.data.mappings;
  },

  async getRawMaterials(): Promise<RawMaterialItem[]> {
    const response = await api.get('/production/byproduct-mappings/raw-materials');
    return response.data.rawMaterials;
  },

  async searchItems(query: string, species?: string): Promise<InventorySearchResult[]> {
    const params: Record<string, string> = { q: query };
    if (species) params.species = species;
    const response = await api.get('/production/byproduct-mappings/search-items', { params });
    return response.data.items;
  },

  async createMapping(data: {
    raw_material_item_number: string;
    byproduct_item_number: string;
    notes?: string;
    created_by?: string;
  }): Promise<ByproductMapping> {
    const response = await api.post('/production/byproduct-mappings', data);
    return response.data.mapping;
  },

  async deleteMapping(id: number): Promise<void> {
    await api.delete(`/production/byproduct-mappings/${id}`);
  },
};

export default byproductMappingService;
